import React from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom"
import { HomePage, UserTasks } from "./components";
import "./App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/user-tasks" element={<UserTasks />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
